import ArrowLink from "components/components/ArrowLink/ArrowLink";
import {
  LinkContentDiv,
  LinkSection,
  LinksContainer,
} from "components/shared/UsefulLinks/style";
import React from "react";
import { customerSolutionUrl, remitRoutes } from "utils/routeConstants";

const ElexonGuidance = (
  <ArrowLink
    to={remitRoutes.remitGuidance}
    isInternalDestination={false}
    text="View REMIT guidance"
  />
);

const RemitData = (
  <ArrowLink
    to={remitRoutes.remit}
    isInternalDestination={true}
    text="View REMIT Data"
  />
);

const CustomerSolution = (
  <ArrowLink
    to={customerSolutionUrl}
    isInternalDestination={false}
    text="View Customer Solution"
  />
);

const UsefulLinks: React.FC = () => (
  <LinksContainer data-test-id="remit-useful-links">
    <LinkSection>
      <LinkContentDiv>
        <h3>REMIT Submission Guidance</h3>
        <p>See Elexon&apos;s guidance on how to submit REMIT files.</p>
      </LinkContentDiv>
      {ElexonGuidance}
    </LinkSection>
    <LinkSection>
      <LinkContentDiv>
        <h3>REMIT Data</h3>
        <p>Submitted REMIT data is displayed on the Insights Solution.</p>
      </LinkContentDiv>
      {RemitData}
    </LinkSection>
    <LinkSection>
      <LinkContentDiv>
        <h3>Customer Solution</h3>
        <p>
          Category A authorised signatories can manage permissions for
          submitting REMIT notifications via the Customer Solution portal.
        </p>
      </LinkContentDiv>
      {CustomerSolution}
    </LinkSection>
  </LinksContainer>
);

export default UsefulLinks;
